import { EInfrastructureActionType } from './types';
import { actionGenerator } from '../../../common/utils/redux/actionGenerator';

export const setActiveType = actionGenerator<EInfrastructureActionType.SetActiveType, number | undefined>(
  EInfrastructureActionType.SetActiveType,
);
